import React, { memo } from 'react';

import Text from './Text';

const Decimal = (props) => {
    return <Text {...props} className="fm-field-decimal" hint="0.0" type="decimal" />;
};

export default memo(Decimal);
